var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRsvpOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 98",
    style: {
      enableBackground: "new 0 0 100 98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.rsvp-online-st0{fill:#78D6E1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "rsvp-online-st0",
    d: "M95.4,31.2C83.3,19.1,67.2,12.4,50,12.4l0,0c-17.2,0-33.3,6.7-45.4,18.8c-2.8,2.8-2.8,7.2,0,10 c1.4,1.4,3.2,2.1,5,2.1s3.6-0.7,5-2.1c9.4-9.5,22-14.7,35.4-14.7l0,0c13.4,0,26,5.2,35.4,14.7c2.8,2.8,7.2,2.8,10,0 C98.2,38.4,98.2,33.9,95.4,31.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rsvp-online-st0",
    d: "M23.4,50.1c-2.8,2.8-2.8,7.2,0,10c1.4,1.4,3.2,2.1,5,2.1s3.6-0.7,5-2.1c9.2-9.2,24.1-9.2,33.2-0.1 c2.7,2.8,7.2,2.8,10,0s2.8-7.2,0-10C61.9,35.4,38.1,35.4,23.4,50.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "rsvp-online-st0",
    cx: 50.1,
    cy: 76.6,
    r: 11
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsvpOnline);
export default __webpack_public_path__ + "static/media/rsvp-online.846d9077a9338fc6bdde5c5ee50bb49e.svg";
export { ForwardRef as ReactComponent };